import administrator from '@/navigation/vertical/administrator'
import app from '@/navigation/vertical/agreements'
import content from './content'
import requirement from './applications'
import pto from './pto'
import storage from './storage'
import reports from './reports'

export default [
  ...administrator,
  ...app,
  ...requirement,
  ...storage,
  ...pto,
  ...reports,
  ...content,
]
